var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutcomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.66699H12C12.3536 2.66699 12.6928 2.80747 12.9428 3.05752C13.1929 3.30756 13.3333 3.6467 13.3333 4.00033V13.3337C13.3333 13.6873 13.1929 14.0264 12.9428 14.2765C12.6928 14.5265 12.3536 14.667 12 14.667H4.00001C3.64638 14.667 3.30724 14.5265 3.0572 14.2765C2.80715 14.0264 2.66667 13.6873 2.66667 13.3337V4.00033C2.66667 3.6467 2.80715 3.30756 3.0572 3.05752C3.30724 2.80747 3.64638 2.66699 4.00001 2.66699H5.33334",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.33301H5.99999C5.63181 1.33301 5.33333 1.63148 5.33333 1.99967V3.33301C5.33333 3.7012 5.63181 3.99967 5.99999 3.99967H10C10.3682 3.99967 10.6667 3.7012 10.6667 3.33301V1.99967C10.6667 1.63148 10.3682 1.33301 10 1.33301Z",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcomeIcon);
export default __webpack_public_path__ + "static/media/outcome-icon.8d526cdbd2fd9c641c3f2fb0d57f017a.svg";
export { ForwardRef as ReactComponent };